import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-2" }

import { computed, onMounted, ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import GaugeRAOS from '@/components/RAOS/GaugeRAOS.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore }         from 'vuex';
import { useI18n } from 'vue-i18n'
import { getAllLatencyLast } from '@/services/Smartlink/Map';
import { getAllUsersData } from '@/services/RAOS/Admin';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getStatusByLatency } from '@/functions/maps';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';




export default /*#__PURE__*/_defineComponent({
  __name: 'TablaStatusRAOS',
  setup(__props) {

const store         = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n()

/********************************
 *********** SERVICES ***********
 *******************************/
const headers = computed(() => [
    { title: t('labels.name'), key: 'name'},
    { title: t('labels.user'), key: 'user'},
    { title: t('labels.status'), key: 'status'},
    { title: t('labels.eficiency'), key: 'eficency'},
    { title: t('labels.operation'), key: 'operation'},
])


const items = ref([])

function getColor(status:string){

  const COLORS:any = {
      ok : COLOR.green,
      alert : COLOR.yellow,
      alarm : COLOR.red,
      down : COLOR.grey,

  }

  return COLORS[status.toLowerCase()]
}

const allPerforadoras   = computed(()=>store.state.arrayListItems);

const finalUsers = ref([])

function showUserInTable(ip:string){
  let userFind = 'Sin Usuario'
  finalUsers.value.filter(({asignado,nombre})=>{
    if(asignado === ip) userFind = nombre
  })
  return userFind
}

function showEficiencyInTable(latency:number){
  let eficencyFind = 0
  if(latency <= 100 && latency > 0) eficencyFind = 93
  else if(latency > 100 && latency <= 500) eficencyFind = 80
  else if(latency > 500) eficencyFind = 35
  else if(latency === -1) eficencyFind = 0.02
  return eficencyFind
}

function showOperationInTable(latency:number){
  let eficencyFind = ''
  if(latency <= 100 && latency > 0) eficencyFind = t('labels.operation_ok')
  else if(latency > 100 && latency <= 500) eficencyFind = t('labels.operation_moderate')
  else if(latency > 500) eficencyFind = t('labels.operation_high')
  else if(latency === -1) eficencyFind = t('labels.operation_down')
  return eficencyFind
}

const finalLatencia = ref<any>([])

async function getAllFinalLatency(){
    const allData = await getAllLatencyLast()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        const finalData = allData.data;
        finalData.forEach((item:any) => {
            if(!finalLatencia.value[item.ip]) {
                finalLatencia.value[item.ip] = {}
            }
            finalLatencia.value[item.ip].latencia = getStatusByLatency(item.latencia)
            finalLatencia.value[item.ip].latenciaValue = item.latencia
        })
    }
}

async function getAllUsers(){
  const allData = await getAllUsersData()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalUsers.value = allData.data;
    }
}

async function getAllStatusInfo(){
  const finalItems = allPerforadoras.value.map((item:any) => (
    {
      ip : item.ip,
      name: item.tag,
      tipo: item.tipo,
      user: showUserInTable(item.ip),
      status: finalLatencia.value[item.ip].latencia,
      latencia: finalLatencia.value[item.ip].latenciaValue,
      eficency: showEficiencyInTable(finalLatencia.value[item.ip].latenciaValue), 
      operation: showOperationInTable(finalLatencia.value[item.ip].latenciaValue),
    }    
  ))
  items.value = finalItems.filter((item:any) => item.tipo.toUpperCase() === 'PERFORADORA')
}

onMounted( async() => {
  getAllUsers()
  await store.dispatch('getInventoryData')
  await getAllFinalLatency()
  await getAllStatusInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "bgtopology",
    class: "ma-4 pa-4 defaultCard text-center"
  }, {
    default: _withCtx(() => [
      (items.value.length > 0)
        ? (_openBlock(), _createBlock(_component_v_data_table, {
            key: 0,
            headers: headers.value,
            items: items.value,
            class: "text-caption allTable",
            density: "compact",
            "item-value": "name",
            "hide-default-footer": "",
            hover: ""
          }, {
            "item.eficency": _withCtx(({ value }) => [
              _createVNode(GaugeRAOS, { value: value }, null, 8, ["value"])
            ]),
            "item.status": _withCtx(({ value }) => [
              _createVNode(_component_v_row, { justify: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: getColor(value)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" mdi-circle ")
                    ]),
                    _: 2
                  }, 1032, ["color"]),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(value.toUpperCase()), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["headers", "items"]))
        : (_openBlock(), _createBlock(Prog_circular, { key: 1 }))
    ]),
    _: 1
  }))
}
}

})